import classNames from 'classnames';

import { Image } from '~components/Image/Image';
import { useBreakpoints } from '~hooks/useBreakpoints';

import styles from './HeaderLogo.module.scss';
import type { HeaderLogoProps } from './HeaderLogo.types';

export function HeaderLogo({
  className,
  logo,
  logoMobile,
  href = '/',
  tagName = 'a',
}: HeaderLogoProps) {
  const TagName = tagName;
  const [, { isMobile }] = useBreakpoints();
  return (
    <TagName href={href} className={classNames(styles.wrapper, className)}>
      {isMobile && logoMobile ? (
        <Image src={logoMobile.src} alt="" className={styles.logoMobile} />
      ) : (
        <Image src={logo.src} alt="" className={styles.logo} />
      )}
    </TagName>
  );
}
